import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {TelegramComponent} from "../modals/chose-group/telegram/telegram.component";
import {Group} from "../../../types/interfaces";
import {StudentRequestComponent} from "../modals/student-request/student-request.component";
import {MyGreenCountry} from "../../../services/mygreencountry/my-greencountry";
import {PracticingComponent} from "../modals/chose-group/practicing/practicing.component";
import {TransferLessonsComponent} from "../modals/transfer-lessons/transfer-lessons.component";

@Component({
    selector: 'app-student-actions',
    templateUrl: './student-actions.component.html',
    styleUrls: ['./student-actions.component.scss'],
})
export class StudentActionsComponent implements OnInit {

    @Input() groups: Group[] | undefined = undefined;
    @Output() openTelegramModalEvent = new EventEmitter<void>();


    isBookAndAccessType: boolean = false;

    constructor(private modalCtrl: ModalController, public myGcService: MyGreenCountry,) {
    }

    ngOnInit() {
        if (this.groups?.length == 1 && this.groups[0].typeCourse == 13) {
            this.isBookAndAccessType = true;
        }
    }


    async openModal(type: string) {
        if (this.groups) {
            await this.openChoseGroupModal(type)

        }
    }

    async openChoseGroupModal(type: string) {

        const modal = await this.modalCtrl.create({
            component: type === 'practicing' ? PracticingComponent : TelegramComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                groups: this.groups,
                type: type,
            }
        });

        modal.onWillDismiss().then(({data, role}) => {
            if (role === 'openTransferModal') {

                this.openTransferModal();
                // Handle the data from the PracticingComponent
            }
        });


        await modal.present();

    }


    async openTransferModal() {
        const modal = await this.modalCtrl.create({
            component: TransferLessonsComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                groups: this.groups,
            }
        });

        await modal.present();
    }


    openUrl(url: string) {
        if (url) {
            this.myGcService.openUrl(url);
        }

    }

    async openRequestModal(type: string) {

        const modal = await this.modalCtrl.create({
            component: StudentRequestComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                type: type,
            }
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();
    }


}
